import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';
import { useObserver } from 'mobx-react-lite';
import _ from 'lodash';

import { getCategoriesForMenuForState } from 'shared/helpers/products';
import useUI from 'hooks/use-ui';
import useDispensary from 'src/dispensary/hooks/use-dispensary';
import useCart from 'hooks/use-cart';
import useDispensaryFlag from 'shared/hooks/use-dispensary-flag';
import { getProductInventoryFilters } from 'utils/helpers/product';

export const dispensaryCategories = gql`
  query DispensaryCategoriesQuery($productsFilter: productsFilterInput!) {
    filteredProducts(filter: $productsFilter) {
      categories
    }
  }
`;

export default function useDispensaryCategories() {
  const { dispensary } = useDispensary();
  const cart = useCart();
  const menuType = useObserver(() => cart.menuType);
  const { isKiosk } = useUI();

  let categories = getCategoriesForMenuForState(dispensary?.location?.state);
  let loadedCategories = dispensary?.activeCategories || [];

  const shouldUseNewInventoryFiltering = useDispensaryFlag(`use-updated-inventory-filtering`, dispensary?.id);

  const productsFilter = {
    dispensaryId: dispensary?.id,
    pricingType: menuType,
    Status: `Active`,
    useCache: true,
    isKioskMenu: isKiosk,
    ...(shouldUseNewInventoryFiltering
      ? { inventoryFilters: getProductInventoryFilters({ dispensary, isKiosk }) }
      : { removeProductsBelowOptionThresholds: true }),
  };
  const { data } = useQuery(dispensaryCategories, {
    skip: !dispensary,
    variables: { productsFilter },
  });

  const productCategories = _.get(data, `filteredProducts.categories`, []);
  if (productCategories.length) {
    loadedCategories = productCategories;
  }
  if (loadedCategories.length) {
    categories = _.filter(categories, (category) => _.includes(loadedCategories, category.value));
  }

  return { categories };
}
